/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import { Card, CardBody, CardHeader } from "reactstrap";
import Disclaimer from "../../../ui/disclaimer";
import headerSvg from "../../../../assets/svg/ic_conciliacion.svg";
import TransferTable from "../transfer-table";
import removeIcon from "../../../../assets/img/shredder.svg";
import ManualManagement from "../manual-management";

const MultipleResume = ({ multipleClients, currency, onDataChange }) => {
  const [localData, setLocalData] = useState([
    ...multipleClients.flatMap(x =>
      x.clientItems.map(y => ({
        ...y,
        tercero: x.tercero,
        label: x.label
      }))
    )
  ]);
  const [manualLocalData, setManualLocalData] = useState([
    ...multipleClients.flatMap(x =>
      x.manualManagement.map(y => ({
        ...y,
        tercero: x.tercero,
        label: x.label
      }))
    )
  ]);
  const [deleteDisclaimerVisible, setDeleteDisclaimerVisible] = useState(false);
  const [errorsVisible, setErrorVisible] = useState(false);
  useEffect(() => {
    setLocalData([...multipleClients.flatMap(x => x.clientItems)]);
    setManualLocalData([...multipleClients.flatMap(x => x.manualManagement)]);
  }, [multipleClients]);

  const handleTransferToggleSelected = value => {
    setLocalData(
      localData.map(x => ({
        ...x,
        selected: x.CO_DOCUMENT_NUMBER === value.CO_DOCUMENT_NUMBER ? !x.selected : x.selected
      }))
    );
  };
  const handleManualSelectChange = (value, index) => {
    setManualLocalData(
      manualLocalData.map((x, i) => ({
        ...x,
        selected: i === index ? !x.selected : x.selected
      }))
    );
  };
  const handleDeleteClick = () => {
    const hasSelected = localData.filter(x => x.selected).length > 0;
    const manualHasSelected = manualLocalData.filter(x => x.selected).length > 0;
    if (hasSelected || manualHasSelected) {
      setDeleteDisclaimerVisible(true);
    }
    setErrorVisible(!hasSelected && !manualHasSelected);
  };
  const handleDeleteAccept = () => {
    setDeleteDisclaimerVisible(false);
    const removedLocal = localData.filter(x => x.selected);
    const removedManual = manualLocalData.filter(x => x.selected);
    onDataChange({
      clientItems: removedLocal,
      manualManagement: removedManual
    });
  };
  return (
    <div className="mt-sm-3  col-12">
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-center">
          <div>
            <img src={headerSvg} alt="Section icon" />
            <span className="ml-3">Propuesta de conciliación</span>
          </div>
          <div role="button" onClick={handleDeleteClick}>
            <span className="button-text">Eliminar</span>
          </div>
        </CardHeader>
        <CardBody className="pl-0 pr-0">
          {errorsVisible && (
            <div className="error-multiple">
              <span>
                Debe seleccionar alguna transferencia o gestión manual para poder eliminarlas.
              </span>
            </div>
          )}
          {localData && localData.length > 0 && (
            <>
              <div className="col-12 mb-4 mt-4">
                <h4>Listado de partidas</h4>
              </div>
              <TransferTable
                noExpand
                currency={currency}
                toggleSelect={handleTransferToggleSelected}
                data={localData || []}
                tableOptions={{
                  emptyElement: <span>No hay elementos para el cliente</span>,
                  pagination: localData && localData.length > 10,
                  filter: false,
                  rowExpansion: false,
                  hasExpansion: false,
                  toolbar: false
                }}
                withSapCode
              />
            </>
          )}
          {manualLocalData && manualLocalData.length > 0 && (
            <>
              <div className="col-12 mb-4 mt-4">
                <h4>Gestión Manual</h4>
              </div>
              <ManualManagement
                toggleSelect={handleManualSelectChange}
                withCheck
                data={manualLocalData}
                canEdit={false}
                currency={currency}
              />
            </>
          )}
        </CardBody>
      </Card>
      <Disclaimer
        icon={<img src={removeIcon} alt="Eliminar usuario" />}
        title="Eliminar partidas"
        text="¿Desea eliminar las partidas y gestiones manuales seleccionadas?"
        acepptButtonText="Eliminar"
        cancelButtonText="Cancelar"
        onAccept={handleDeleteAccept}
        onCancel={() => setDeleteDisclaimerVisible(false)}
        visible={deleteDisclaimerVisible}
      />
    </div>
  );
};

MultipleResume.propTypes = {
  intl: intlShape.isRequired,
  multipleClients: PropTypes.array,
  currency: PropTypes.string,
  onDataChange: PropTypes.func
};

MultipleResume.defaultProps = {
  multipleClients: [],
  currency: "€",
  onDataChange: () => {}
};

export default injectIntl(MultipleResume);
